import {
    apiRequest,
    bobotKomponenPenilaianDetail, 
    bobotKomponenPenilaianUpdate,
} from "../../../../../../services/adapters/master/bobotKomponenPenilaianService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", bobotKomponenPenilaianDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", bobotKomponenPenilaianUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository